export const FETCH_TEAMS = "FETCH_TEAMS";
export const FETCH_TEAMS_FULFILLED = "FETCH_TEAMS_FULFILLED";
export const FETCH_TEAMS_PENDING = "FETCH_TEAMS_PENDING";
export const FETCH_TEAMS_REJECTED = "FETCH_TEAMS_REJECTED";
export const INCREMENT_TEAM_UNREAD = "INCREMENT_TEAM_UNREAD";
export const CLEAR_TEAM_UNREAD = "CLEAR_TEAM_UNREAD";